var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("p", { staticClass: "chart-title" }, [
        _vm._v(
          "\n        Charts showing how different habitats fall within MPAs and byelaws restricting bottom towed fishing gear. Use the\n        dropdown to switch between areas of interest.\n    "
        ),
      ]),
      _vm._v(" "),
      _vm.habitatsData
        ? _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "font-size": "90%" } },
            [
              _vm._v("\n        Select area of interest:\n        "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.areaSelected,
                      expression: "areaSelected",
                    },
                  ],
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.areaSelected = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.availableAreas, function (area) {
                  return _c("option", [
                    _vm._v(
                      "\n                " + _vm._s(area) + "\n            "
                    ),
                  ])
                }),
                0
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { id: "habitats" } }),
      _vm._v(" "),
      _c("area-legend"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }